// import jsPDF from "jspdf";
// import { autoTable } from 'jspdf-autotable'

// const DownloadPdf = (columns, data, tableName, titleText) => {
//   const doc = new jsPDF();
//   let tableRows;

//   //   const tableColumnNames = ["Sl no", "Name", "Email", "Mobile", "Role", "Employee ID"]; // Replace with your actual column names

//   // Calculate the width of the title and the table to center them
//   const titleWidth =
//     doc.getStringUnitWidth(titleText) * doc.internal.getFontSize();
//   const tableWidth = doc.internal.pageSize.getWidth();
//   const xOffset = (tableWidth - titleWidth) / 3;

//   // Add the title to the PDF
//   doc.text(titleText, xOffset, 14);

//   if (tableName == "Hr_Jobvacancies_Managment") {
//     tableRows = data.map((item) => [
//       item.sl,
//       item.coloum1,
//       item.coloum2,
//       item.coloum3,
//       item.coloum4,
//       item.coloum5,
//       item.coloum6
//     ]);
//   } else if (tableName == "Ieltsentrolledstudents") {
//     tableRows = data.map((item) => [
//       item.sl,
//       item.coloum1,
//       item.coloum2,
//       item.coloum3,
//       item.coloum4,
//       item.coloum5,
//       item.coloum6,
//       item.coloum7,
//       item.coloum8,
//       item.coloum9,
//       item.coloum10
//     ]);
//   } else if (tableName == "EntrolledTeacherList") {
//     tableRows = data.map((item, index) => [
//       index + 1,
//       item.teacherName,
//       item.teacherEmail,
//       item.teacherPhone,
//       item.center,
//       item.teacherSpecialization,
//       item.status
//     ]);
//   } else if (tableName == "OnlinePurchasedStudentList") {
//     tableRows = data.map((item, index) => [
//       index + 1,
//       item?.ielts_entrolled_student?.fullName,
//       item?.ielts_entrolled_student?.dob,
//       item?.ielts_entrolled_student?.gender,
//       item?.ielts_entrolled_student?.email,
//       item?.ielts_entrolled_student?.phoneNumber,
//       item?.ielts_entrolled_student?.whatsAppNumber,
//       item?.ielts_course?.CourseName,
//       item?.ielts_entrolled_student?.status
//     ]);
//   } else if (tableName == "OfflinePurchasedStudentList") {
//     tableRows = data.map((item, index) => [
//       index + 1,
//       item?.ielts_entrolled_student?.fullName,
//       item?.ielts_entrolled_student?.dob,
//       item?.ielts_entrolled_student?.gender,
//       item?.ielts_entrolled_student?.email,
//       item?.ielts_entrolled_student?.phoneNumber,
//       item?.ielts_entrolled_student?.whatsAppNumber,
//       item?.ielts_course?.CourseName,
//       item?.ielts_center?.CenterName,
//       item?.payment,
//       item?.ielts_teacher?.teacherName,
//       item?.ielts_entrolled_student?.status
//     ]);
//   } else if (tableName == "ALL_TICKETS_TABLE") {
//     tableRows = data.map((item, index) => [
//       index + 1,
//       item?.ielts_entrolled_student?.fullName,
//       item?.ielts_entrolled_student?.dob,
//       item?.ielts_entrolled_student?.gender,
//       item?.ielts_entrolled_student?.email,
//       item?.ielts_entrolled_student?.phoneNumber,
//       item?.ielts_entrolled_student?.whatsAppNumber,
//       item?.ielts_course?.CourseName,
//       item?.ielts_center?.CenterName,
//       item?.payment,
//       item?.ielts_teacher?.teacherName,
//       item?.ielts_entrolled_student?.status
//     ]);
//   } else if (tableName == "Employee_Managment") {
//     tableRows = data.map((item, index) => [
//       index + 1,
//       item?.ielts_entrolled_student?.fullName,
//       item?.ielts_entrolled_student?.dob,
//       item?.ielts_entrolled_student?.gender,
//       item?.ielts_entrolled_student?.email,
//       item?.ielts_entrolled_student?.phoneNumber,
//       item?.ielts_entrolled_student?.whatsAppNumber,
//       item?.ielts_course?.CourseName,
//       item?.ielts_center?.CenterName,
//       item?.payment,
//       item?.ielts_teacher?.teacherName,
//       item?.ielts_entrolled_student?.status
//     ]);
//   } else if (tableName == "sceduledMeeting") {
//     tableRows = data.map((item, index) => [
//       index + 1,
//       item?.name,
//       item?.counsilorName,
//       item?.sceduledDate,
//       item?.sceduledTime,
//       item?.status
//     ]);
//   } else if (tableName == "Role_Managment") {
//     tableRows = data.map((item, index) => [
//       index + 1,
//       item.name,
//       item.description,
//       item?.bulkID,
//       "admin",
//       item.lastupdateby
//     ]);
//   } else if(tableName === "Lead_Management") {
//     console.log(133,"lead management is working");
//     tableRows = data.map((item, index) => [
//       index + 1,
//       item?.name,
//       item?.email,
//       item?.phone,
//       item?.whatsappNumber,
//       item?.passportNumber,
//       item?.preferredCountry,
//       item?.leadSource,
//       item?.leadOwner,
//       item?.leadBranch,
//       item?.status,
//       item?.priority,
//       item?.leadCity,
//       item?.leadTeleCaller,
//       item?.TeleCallerNote,
//       item?.leadCounsilor,
//       item?.CounsilorNote,
//       item?.marketingNote
//     ])
//   } else {
//     tableRows = data.map((item) => [
//       item.sl,
//       item.name,
//       item.description,
//       item.updatedby,
//       item.lastupdateby
//     ]);
//   }

//   autoTable({
//     head: [columns.map((item) => item.title)],
//     body: tableRows,
//     startY: 20,
//   });

//   doc.save(tableName);
// };

// export default DownloadPdf;

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const DownloadPdf = (columns, data, tableName, titleText) => {
  // Create a new jsPDF instance with more modern configuration  
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a4"
  });

  // Set font and size
  doc.setFontSize(12);

  let tableRows;

  // Function to handle different table types
  const getTableRows = () => {
    switch (tableName) {
      case "Hr_Jobvacancies_Managment":
        return data.map((item) => [
          item?.sl,
          item?.coloum1,
          item?.coloum2,
          item?.coloum3,
          item?.coloum4,
          item?.coloum5,
          item?.coloum6
        ]);

      case "Ieltsentrolledstudents":
        return data.map((item) => [
          item?.sl,
          item?.coloum1,
          item?.coloum2,
          item?.coloum3,
          item?.coloum4,
          item?.coloum5,
          item?.coloum6,
          item?.coloum7,
          item?.coloum8,
          item?.coloum9,
          item?.coloum10
        ]);

      case "EntrolledTeacherList":
        return data.map((item, index) => [
          index + 1,
          item?.teacherName,
          item?.teacherEmail,
          item?.teacherPhone,
          item?.center,
          item?.teacherSpecialization,
          item?.status
        ]);

      case "OnlinePurchasedStudentList":
        return data.map((item, index) => [
          index + 1,
          item?.ielts_entrolled_student?.fullName,
          item?.ielts_entrolled_student?.dob,
          item?.ielts_entrolled_student?.gender,
          item?.ielts_entrolled_student?.email,
          item?.ielts_entrolled_student?.phoneNumber,
          item?.ielts_entrolled_student?.whatsAppNumber,
          item?.ielts_course?.CourseName,
          item?.ielts_entrolled_student?.status
        ]);

      case "OfflinePurchasedStudentList":
        return data.map((item, index) => [
          index + 1,
          item?.ielts_entrolled_student?.fullName,
          item?.ielts_entrolled_student?.dob,
          item?.ielts_entrolled_student?.gender,
          item?.ielts_entrolled_student?.email,
          item?.ielts_entrolled_student?.phoneNumber,
          item?.ielts_entrolled_student?.whatsAppNumber,
          item?.ielts_course?.CourseName,
          item?.ielts_center?.CenterName,
          item?.payment,
          item?.ielts_teacher?.teacherName,
          item?.ielts_entrolled_student?.status
        ]);

      case "ALL_TICKETS_TABLE":
        return data.map((item, index) => [
          index + 1,
          item?.ielts_entrolled_student?.fullName,
          item?.ielts_entrolled_student?.dob,
          item?.ielts_entrolled_student?.gender,
          item?.ielts_entrolled_student?.email,
          item?.ielts_entrolled_student?.phoneNumber,
          item?.ielts_entrolled_student?.whatsAppNumber,
          item?.ielts_course?.CourseName,
          item?.ielts_center?.CenterName,
          item?.payment,
          item?.ielts_teacher?.teacherName,
          item?.ielts_entrolled_student?.status
        ]);

      case "Employee_Managment":
        return data.map((item, index) => [
          item.sl,
          item?.employeeId,
          item?.name,
          item?.description,
          item?.updatedby,
          item?.lastupdateby,
          item?.branch.map((value) => value),
          item?.status
        ]);

      case "sceduledMeeting":
        return data.map((item, index) => [
          index + 1,
          item?.name,
          item?.counsilorName,
          item?.sceduledDate,
          item?.sceduledTime,
          item?.status
        ]);

      case "Role_Managment":
        return data.map((item, index) => [
          index + 1,
          item?.name,
          item?.description,
          item?.bulkID,
          "admin",
          item?.lastupdateby
        ]);

      case "dead_Management":
        return data.map((item, index) => [
          index + 1,
          item?.name,
          item?.email,
          item?.phone,
          item?.whatsappNumber,
          item?.preferredCountry,
          item?.leadSource,
          item?.leadOwner,
          item?.leadBranch,
          item?.status,
          item?.priority,
          item?.leadCity,
          item?.leadTeleCaller,
          item?.leadCounsilor,
          item?.reason
        ])

      case "Lead_Management":
        return data.map((item, index) => [
          index + 1,
          item?.name,
          item?.email,
          item?.phone,
          item?.whatsappNumber,
          item?.passportNumber,
          item?.preferredCountry,
          item?.leadSource,
          item?.leadOwner,
          item?.leadBranch,
          item?.status,
          item?.priority,
          item?.leadCity,
          item?.leadTeleCaller,
          item?.leadCounsilor,
          item?.reason
        ]);

      case "Deal_Management":
        return data.map((item, index) => [
          index + 1,
          item?.name,
          item?.email,
          item?.phone,
          item?.whatsappNumber,
          item?.passportNumber,
          item?.preferredCountry,
          item?.leadSource,
          item?.leadOwner,
          item?.leadBranch,
          item?.status,
          item?.priority,
          item?.leadCity,
          item?.leadTeleCaller,
          item?.leadCounsilor,
        ]);

      case "Defferal_Management":
        return data.map((item, index) => [
          item?.sl,
          item?.name,
          item?.email,
          item?.phone,
          item?.whatsappNumber,
          item?.leadSource,
          item?.leadCity,
          item?.prefferedCountry,
          item?.leadBranch,
          item?.intakeMonth,
          item?.intakeYear,
          item?.leadTeleCaller,
          item?.leadCounsilor
        ]);
      case "Drop_Management":
        return data.map((item, index) => [
          item?.sl,
          item?.name,
          item?.email,
          item?.phone,
          item?.whatsappNumber,
          item?.preferredCountry,
          item?.leadSource,
          item?.leadOwner,
          item?.leadBranch,
          item?.status,
          item?.priority,
          item?.leadCity,
          item?.Reason,
          item?.leadTeleCaller,
          item?.leadCounsilor
        ]);
      case "Declaration_Management":
        return data.map((item, index) => [
          index + 1,
          item?.lead?.firstName,
          item?.universityCountry,
          item?.courseName,
          item?.universityName,
          item?.user?.firstName,
          item?.intakeDate,
          item?.methodStatus
        ]);
      case "Partner_Management":
        return data.map((item, index) => [
          index + 1,
          item?.lead?.firstName,
          item?.lead?.email,
          item?.lead?.mobileNumber,
          item?.lead?.universityName,
          item?.lead?.passport,
          item?.universityCountry,
          item?.courseName,
          item?.lead?.partner?.name,
          item?.UserTeamLeadStaff?.firstName,
          item?.intakeDate,
          item?.status ? item?.status : "-"
        ]);
      case "Partner_enrolled_Management":
        return data.map((item, index) => [
          index + 1,
          item?.lead?.firstName,
          item?.universityCountry,
          item?.courseName,
          item?.lead?.partner?.name,
          item?.lead?.partner?.user?.firstName,
          item?.UserTeamLeadStaff?.firstName,
          item?.intakeDate,
          item?.methodStatus
        ]);
      case "Partner_Create_Management":
        return data.map((item, index) => [
          index + 1,
          item?.name,
          item?.email,
          item?.phone,
          item?.user?.firstName,
          item?.isVerified ? "Verified" : "Not Verified"
        ]);

      case "Allapplication_Management":
        return data.map((item, index) => [
          index + 1, // Sl no
          item?.lead?.firstName || "", // Student name
          item?.lead?.lead_personal_details?.[0]?.passportNumber || "", // Passport Number
          item?.lead?.email || "", // Email
          item?.lead?.mobileNumber || "", // Phone Number
          item?.universityCountry || "", // Country
          item?.courseName || "", // Course
          item?.universityName || "", // University
          item?.universityHandlerId || "", // University Handler
          item?.lead?.leadOwnerName || "", // Lead owner
          item?.lead?.Counselor?.firstName || "", // Counsilor
          item?.lead?.Telecaller?.firstName || "", // Telecaller
          item?.intakeDate || "", // Intake
          item?.createdAt || "", // Application Started Date
          item?.methodStatus || "", // Status
          item?.lead?.deferalIntakeMonth || "", // Deferal intake month
          item?.lead?.deferalIntakeYear || "", // Deferal intake year
          item?.paymentStatus || "" // Payment status
        ]);

      case "Enrolled_Application_Management":
        return data.map((item, index) => [
          index + 1,
          item?.lead?.firstName,
          item?.lead?.lead_personal_details[0]?.passportNumber,
          item?.lead?.email,
          item?.lead?.mobileNumber,
          item?.universityCountry,
          item?.courseName,
          item?.universityName,
          item?.user?.firstName,
          item?.intakeDate,
          item?.createdAt,
          item?.methodStatus,
          item?.paymentStatus
        ]);

      case "Refer_and_Earn":
        return data.map((item, index) => [
          index + 1,
          item?.name,
          item?.createdAt,
          item?.email,
          item?.phoneNumber,
          item?.country,
          item?.referredBy,
          item?.status
        ]);

      case "Entrolled_Teacher_List":
        return data.map((item, index) => [
          index + 1,
          item?.teacherName,
          item?.teacherEmail,
          item?.teacherPhone,
          item?.center,
          item?.teacherSpecialization,
          item?.status
        ]);

      case "slotList":
        return data.map((item, index) => [
          index + 1,
          item?.date,
          item?.slotTimes?.[0]
            ? `${item.slotTimes[0].timeFrom} - ${item.slotTimes[0].timeTo}`
            : "",
          item?.user?.firstName,
          item?.status
        ]);

      case "Incentive_Report":
        return data.map((item, index) => [
          index + 1,
          item?.universityName,
          item?.studentName,
          item?.university,
          item?.course,
          item?.date,
          item?.status
        ]);

      case "Bonus_Report":
        return data.map((item, index) => [
          index + 1,
          item?.employeeId,
          item?.name,
          item?.role,
          item?.enrollmentCount
        ]);

      default:
        return data.map((item) => [
          item?.sl,
          item?.name,
          item?.description,
          item?.updatedby,
          item?.lastupdateby
        ]);
    }
  };

  // Get table rows
  tableRows = getTableRows();

  // Calculate page width and title positioning
  const pageWidth = doc.internal.pageSize.getWidth() - 20;
  const titleFontSize = 16;
  doc.setFontSize(titleFontSize);

  // Add title to the PDF
  const titleWidth = doc.getTextWidth(titleText);
  const xOffset = (pageWidth - titleWidth) / 2;
  doc.text(titleText, xOffset, 10);

  // Add sl no column if not present
  if (
    columns.length === 0 ||
    columns[0].title.toLowerCase() !== "Sl no".toLowerCase()
  ) {
    columns.unshift({ title: "Sl No" });
  }

  const columnCount = columns.length;

  let columnWidth;
  if (columnCount <= 6) {
    columnWidth = "wrap";
  } else {
    columnWidth = pageWidth / columnCount; 
  }

  // Generate table using autoTable
  autoTable(doc, {
    head: [columns.map((item) => item.title)],
    body: tableRows,
    startY: 20,
    styles: {
      fontSize: columnCount > 12 ? 4 : 8, 
      cellPadding: 2,
      overflow: "linebreak"
    },
    columnStyles: {
      ...Object.fromEntries(
        columns.map((_, i) => [i, { cellWidth: columnWidth }])
      )
    },
    willDrawCell: (data) => {
      // Optional: custom cell styling
      if (data.section === "head") {
        data.cell.styles.textColor = [30, 60, 120]; // Example: Blue header text
      }
      data.cell.styles.fillColor =
        data.row.index % 2 === 0 ? [240, 240, 240] : [255, 255, 255];
    },
    horizontalPageBreak: false,
    theme: "striped"
  });

  // Save the PDF
  doc.save(`${tableName}${Date.now()}.pdf`);
};

export default DownloadPdf;
